import { HttpBackend, HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HrmsService {

  // MAIN COMPONENT CSS WIDTH CHANGE //

  private widthSubject = new BehaviorSubject<any>('100%');
  width$ = this.widthSubject.asObservable();

  updateWidth(width: any) {
    this.widthSubject.next(width);
  }

  // HEADER AND SIDE BAR CHANGE CSS //

  private collapsed = new BehaviorSubject<boolean>(false);
  collapsed$ = this.collapsed.asObservable();

  //CHANGE SIDE BAR MENU LIST //

  // private viewSubject = new BehaviorSubject<string>('grievance');
  private viewSubject = new BehaviorSubject<string>('');
  view$ = this.viewSubject.asObservable();

  setView(viewName: string) {
    localStorage.setItem('routeNames', viewName);
    this.viewSubject.next(viewName);
  }

  toggleCollapse() {
    this.collapsed.next(!this.collapsed.value);
  }

  openSidebar() {
    this.collapsed.next(false);
  }

  // hide the selector //
  private reportsSelectedSource = new BehaviorSubject<boolean>(false);
  reportsSelected$ = this.reportsSelectedSource.asObservable();

  setReportsSelected(value: boolean) {
    this.reportsSelectedSource.next(value);
  }

  private token = ''
  constructor(private http: HttpClient) { }

  getSubjectDetails() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/hrms/reports/subjectDetails', { headers });
  }

  getDeptdesign() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/hrms/reports/deptDesigMasterDetails', { headers })
  }

  getCostcenterdetails() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/hrms/reports/costCenterDetails', { headers })
  }

  getEmployeeExitDetails(monthYear: string) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const url =
      environment.printasseturl +
      '/employee/api/jwtV2/hrms/reports/employeeExitReport?monthYear=' +
      encodeURIComponent(monthYear);
    return this.http.get(url, { headers });
  }

  getRolemanagement(payrollId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/common/userRoles?payrollId=' + payrollId, { headers });
  }

}
